export default __webpack_public_path__ + "static/media/pizza5.c32308bc.jpg";